
import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { AlertTriangle } from 'lucide-react';

interface LoadingProps {
  isLoading: boolean;
  error: string | null;
}

const LoadingStates: React.FC<LoadingProps> = ({ isLoading, error }) => {
  if (isLoading) {
    return (
      <div className="w-full h-full flex flex-col gap-4">
        <Skeleton className="w-full h-[600px] rounded-lg" />
        <Skeleton className="w-full h-64 rounded-lg" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full h-full flex flex-col gap-4">
        <div className="p-8 text-center border border-red-200 rounded-lg bg-red-50">
          <div className="flex justify-center mb-4">
            <AlertTriangle className="h-10 w-10 text-red-500" />
          </div>
          <h3 className="text-lg font-medium text-red-800 mb-2">Error Loading Map</h3>
          <p className="text-red-500 mb-4">{error}</p>
          <button 
            onClick={() => window.location.reload()} 
            className="mt-4 px-4 py-2 bg-tribal-primary text-white rounded-md hover:bg-tribal-primary/90"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default LoadingStates;
